import React, { useEffect, useState } from "react";
import axios from "axios";
import sharedStyles from "../styles/shared.module.css";
import adminStyles from "../styles/AdminProdutos.module.css";

import ProdutoForm from "./Components/ProdutoForm";
import ProdutoList from "./Components/ProdutoList";

type ProdutoDTO = {
  id?: number;
  titulo: string;
  descricao: string;
  precoBase: number;
  servicoId?: number;
  servicoNome?: string;
  fotoIds?: number[];
  fotoUrls?: string[];
  duracaoEmMinutos?: number;
  idiomas?: string[];
  idadeMinima?: number;
  publicoAlvo?: string;
};

type Servico = { id: number; nome: string };

const publicoLabels: Record<string, string> = {
  ADULTOS: "Adultos",
  CRIANCAS_ACOMPANHADAS: "Crianças acompanhadas",
  FAMILIA: "Família",
};

const AdminProdutos = () => {
  const BASE_URL = process.env.REACT_APP_API_URL!;
  const token = localStorage.getItem("token")!;
  const headers = { Authorization: `Bearer ${token}` };

  const [produtos, setProdutos] = useState<ProdutoDTO[]>([]);
  const [servicos, setServicos] = useState<Servico[]>([]);
  const [editingProduto, setEditingProduto] = useState<ProdutoDTO | null>(null);
  const [activeTab, setActiveTab] = useState<"form" | "list">("form");

  // Form states
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [preco, setPreco] = useState<string>("");
  const [servicoId, setServicoId] = useState<number | undefined>();
  const [duracao, setDuracao] = useState<number | undefined>();
  const [idiomas, setIdiomas] = useState<string[]>([]);
  const [idadeMinima, setIdadeMinima] = useState<number | undefined>();
  const [publicoAlvo, setPublicoAlvo] = useState<string>("");
  const [fotosPreview, setFotosPreview] = useState<File[]>([]);

  // Fetch produtos e serviços
  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/admins/produtos`, { headers });
        setProdutos(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    const fetchServicos = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/servicos`, { headers });
        setServicos(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProdutos();
    fetchServicos();
  }, []);

  const resetForm = () => {
    setEditingProduto(null);
    setTitulo("");
    setDescricao("");
    setPreco("");
    setServicoId(undefined);
    setDuracao(undefined);
    setIdiomas([]);
    setIdadeMinima(undefined);
    setPublicoAlvo("");
    setFotosPreview([]);
  };

  const handleEdit = (produto: ProdutoDTO) => {
    setEditingProduto(produto);
    setTitulo(produto.titulo);
    setDescricao(produto.descricao);
    setPreco(produto.precoBase.toString());
    setServicoId(produto.servicoId);
    setDuracao(produto.duracaoEmMinutos);
    setIdiomas(produto.idiomas || []);
    setIdadeMinima(produto.idadeMinima);
    setPublicoAlvo(produto.publicoAlvo || "");
    // Para edição, não carregamos arquivos do servidor como File, apenas URLs
    setFotosPreview([]);
    setActiveTab("form");
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Tem certeza que deseja deletar este produto?")) return;
    try {
      await axios.delete(`${BASE_URL}/admins/produtos/${id}`, { headers });
      setProdutos(prev => prev.filter(p => p.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  const handleUploadFotosPreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    setFotosPreview(prev => [...prev, ...Array.from(e.target.files!)]);
  };


  const handleRemoveFotoPreview = (index: number) => {
    setFotosPreview(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className={sharedStyles.container}>
      <h1>Gerenciar Produtos</h1>

      <div className={adminStyles.tabs}>
        <button
          className={activeTab === "form" ? adminStyles.activeTab : ""}
          onClick={() => setActiveTab("form")}
        >
          Formulário
        </button>
        <button
          className={activeTab === "list" ? adminStyles.activeTab : ""}
          onClick={() => setActiveTab("list")}
        >
          Lista de Produtos
        </button>
      </div>

      <div className={adminStyles.tabContent}>
        {activeTab === "form" && (
          <ProdutoForm
            titulo={titulo} setTitulo={setTitulo}
            descricao={descricao} setDescricao={setDescricao}
            preco={preco} setPreco={setPreco}
            servicoId={servicoId} setServicoId={setServicoId} servicos={servicos}
            duracao={duracao} setDuracao={setDuracao}
            idiomas={idiomas} setIdiomas={setIdiomas}
            idadeMinima={idadeMinima} setIdadeMinima={setIdadeMinima}
            publicoAlvo={publicoAlvo} setPublicoAlvo={setPublicoAlvo} publicoLabels={publicoLabels}
            fotos={fotosPreview}
            handleUploadFotos={handleUploadFotosPreview}
            handleRemoveFoto={handleRemoveFotoPreview}
            editingProduto={editingProduto}
            resetForm={resetForm}
            BASE_URL={BASE_URL}
            token={token}
          />
        )}
        {activeTab === "list" && (
          <ProdutoList
            produtos={produtos}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            publicoLabels={publicoLabels}
            baseUrl={BASE_URL} // ✅ passa a URL do backend
          />
        )}
      </div>
    </div>
  );
};

export default AdminProdutos;
